module.exports = __webpack_public_path__ + "static/img/PC-6.adeabec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcga/PC-6.png
// module id = 9lKY
// module chunks = 0